module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage4_m.a26c88b3444703fe54f3c22abb6dd1c1.jpg";